const m2s = 60;
const h2s = m2s * 60;
const d2s = h2s * 24;
const w2s = d2s * 7;
const M2s = d2s * 30;
const y2s = d2s * 365;

function checkNotNullObject(obj1, obj2) {
  return !obj1 || !obj2 || obj1.id === obj2.id;
}

export class BiaUtils {
  static timeFn = null;
  static getTimeFn() {
    if (BiaUtils.timeFn) {
      return BiaUtils.timeFn;
    }

    const appkeyvalues = JSON.parse(localStorage.getItem('appKeyValues'));
    const timeFunction = appkeyvalues.FN_BIA_IMPACT_MAO_DISPLAY;

    BiaUtils.timeFn = new Function(
      'year',
      'month',
      'week',
      'day',
      'hour',
      'minute',
      'second',
      timeFunction
    );

    return BiaUtils.timeFn;
  }
  static filterTabData(
    data,
    tabArgs,
    filterFn = 'filter',
    includeNull = false
  ) {
    const taLocation = tabArgs.location;
    const taProcess = tabArgs.biaProcess;
    if (!(data && data.length && (taLocation || taProcess || includeNull))) {
      return data;
    }
    return data[filterFn](({ process, location }) => {
      const matchLocation = checkNotNullObject(taLocation, location);
      const matchProcess = checkNotNullObject(taProcess, process);
      if (taLocation && taProcess) {
        if (matchLocation && matchProcess) {
          return true;
        }
      } else {
        if (taLocation && matchLocation) {
          return true;
        }
        if (taProcess && matchProcess) {
          return true;
        }
      }

      return includeNull && !(taLocation || taProcess);
    });
  }

  static calculateSeconds(timeObj) {
    if (!timeObj) {
      return 0;
    }
    const {
      year: y = 0,
      month: M = 0,
      week: w = 0,
      day: d = 0,
      hour: h = 0,
      minute: m = 0,
      second: s = 0,
    } = timeObj;

    return y * y2s + M * M2s + w * w2s + d * d2s + h * h2s + m * m2s + +s;
  }

  static calculateTime(noOfSeconds) {
    let remainingSeconds = noOfSeconds;
    const year = Math.floor(remainingSeconds / y2s);
    remainingSeconds = remainingSeconds % y2s;
    const month = Math.floor(remainingSeconds / M2s);
    remainingSeconds = remainingSeconds % M2s;
    const week = Math.floor(remainingSeconds / w2s);
    remainingSeconds = remainingSeconds % w2s;
    const day = Math.floor(remainingSeconds / d2s);
    remainingSeconds = remainingSeconds % d2s;
    const hour = Math.floor(remainingSeconds / h2s);
    remainingSeconds = remainingSeconds % h2s;
    const minute = Math.floor(remainingSeconds / m2s);
    const second = Math.round(remainingSeconds % m2s);

    return { year, day, month, week, hour, minute, second };
  }

  static getTimeString(timeObj): string {
    const year = timeObj.year || 0;
    const month = timeObj.month || 0;
    const week = timeObj.week || 0;
    const day = timeObj.day || 0;
    const hour = timeObj.hour || 0;
    const minute = timeObj.minute || 0;
    const second = timeObj.second || 0;
    return BiaUtils.getTimeFn()(year, month, week, day, hour, minute, second);
  }
  static sortTime(a, b) {
    if (!(a && b)) {
      return 0;
    }
    return BiaUtils.calculateSeconds(a) - BiaUtils.calculateSeconds(b);
  }
  static processTimeString(times) {
    return times.map((time) =>
      time
        ? {
            ...time,
            display: BiaUtils.getTimeString(time),
          }
        : time
    );
  }

  static calculateOwnImpactRto(
    { store, loadImpact, getImpact, map },
    biaId,
    ownedProcess
  ) {
    store.dispatch(loadImpact({ id: biaId }));

    return store.select(getImpact, { id: biaId }).pipe(
      map((impacts) => {
        const ownImpact = BiaUtils.getImpactByProcess(
          impacts,
          ownedProcess?.id
        );
        const ownImpactRto = BiaUtils.getImpactRto(ownImpact);
        return { rtos: [ownImpactRto], impacts };
      })
    );
  }
  static getImpactByProcess(allImpacts, processId) {
    return allImpacts?.find((impact) => impact.process?.id === processId);
  }
  static getImpactRto(ownImpact) {
    return ownImpact ? ownImpact.overrideRtoValue || ownImpact.saRtoDto : null;
  }
  static getNavTabIndex(
    list: any[],
    currentTabIndex: number,
    navFlag: string
  ): number {
    const navItem =
      navFlag === 'next' ? currentTabIndex + 1 : currentTabIndex - 1;
    return navItem >= 0 ? navItem : -1;
  }
}
